import React from 'react';
import './GoTalkForm.scss';
import ContactForm from '../ContactForm';


function GoTalkForm({t, onFormSuccess, onFormFail}) {
 
  return (
    <div className="talk-wrapper">
        <div className="talk-content">
            <div className="talk-description">
                <div className="talk-capture">
                    {t("go_talk_capture")}
                </div>
                <div className="talk-text">
                    {t("go_talk_description1")}
                   <p>{t("go_talk_description2")}</p>
                </div>
                <div className="talk-bottom">
                    info@weexpert.io
                </div>
            </div>
            <div className="talk-form">
                <ContactForm t={t} onFormSuccessSubmit={onFormSuccess} onFormFailSubmit={onFormFail}/>
            </div>
        </div>
    </div>
  );
}

export default GoTalkForm;